import "./modal.css";

import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const LoadingModal = ({ isOpen }) => {
  const modalClass = classNames({
    "opacity-0 pointer-events-none": !isOpen,
    "modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-20": true
  });
  return (
    <div className={modalClass}>
      <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
      <div className="modal-content py-4 text-left px-6 text-xl	flex items-center">
        <span className="fa-2x mr-3">
          <i className="fa fa-circle-notch fa-pulse text-blue-500" />
        </span>
        <span>Loading...</span>
      </div>
    </div>
  );
};

LoadingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default LoadingModal;
